import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import LandingPage from './components/LandingPage';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import AdminDashboard from './components/AdminDashboard';
import GlobalHeader from './components/GlobalHeader';
import { getTokenPayload, logout, verifyAuth } from './auth';

function Content({ auth, setAuth }) {
  // Theme State: 'dark' (default) or 'bw' (Black & White)
  const [theme, setTheme] = useState('dark');

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'bw' : 'dark');
  };

  return (
    <div className={`min-h-screen flex flex-col font-sans selection:bg-accent-500 selection:text-white transition-colors duration-500 ${theme === 'bw' ? 'theme-bw bg-white' : 'bg-dark-900 text-white'}`}>

      {/* Global Header everywhere */}
      <GlobalHeader auth={auth} setAuth={setAuth} theme={theme} toggleTheme={toggleTheme} />

      <div className="flex-grow pt-20">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={auth ? <Navigate to="/reports" /> : <Login onAuth={() => setAuth(getTokenPayload())} />} />
          <Route path="/register" element={auth ? <Navigate to="/reports" /> : <Register onAuth={() => setAuth(getTokenPayload())} />} />
          <Route path="/reports" element={auth ? <App theme={theme} /> : <Navigate to="/login" />} />
          <Route
            path="/admin"
            element={
              auth?.role === 'admin'
                ? <AdminDashboard theme={theme} />
                : auth
                  ? <Navigate to="/reports" />
                  : <Navigate to="/login" />
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>

      <footer className={`py-6 text-center text-sm border-t transition-colors duration-300 ${theme === 'bw' ? 'bg-gray-100 border-gray-200 text-gray-500' : 'bg-dark-900 border-white/5 text-gray-600'}`}>
        <p>&copy; {new Date().getFullYear()} <span className="font-medium opacity-80">RoadWatch</span>. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default function RootApp() {
  const [auth, setAuth] = useState(() => getTokenPayload());

  useEffect(() => {
    const h = () => setAuth(getTokenPayload());
    window.addEventListener('storage', h);
    return () => window.removeEventListener('storage', h);
  }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      const verified = await verifyAuth();
      if (!active) return;
      if (!verified) {
        logout();
        setAuth(null);
      } else {
        setAuth(verified.tokenPayload);
      }
    })();
    return () => { active = false; };
  }, []);

  return (
    <BrowserRouter>
      <Content auth={auth} setAuth={setAuth} />
    </BrowserRouter>
  );
}
